import { CSSProperties } from 'react';

import {
	BrandingType,
	ManifestType,
} from '../Components/AppConfig/AppConfigContext';

/**
 * Construye el style inline para aplicar como `backgroundImage` de una vista
 * pública, usando la imagen del `manifest.branding` si existe y cayendo a un
 * asset por defecto cuando no.
 *
 * El style devuelto es vacío (`{}`) si no hay URL — se respetan los estilos
 * del SCSS subyacente sin pisarlos con `undefined`.
 *
 * Uso típico:
 *   <div style={getBrandingBackground(manifest, 'background_signup', '/assets/x.png')}>
 */
export default function getBrandingBackground(
	manifest: ManifestType | undefined,
	key: keyof BrandingType,
	fallback?: string
): CSSProperties {
	const url = manifest?.branding?.[key]?.value ?? fallback;
	return url ? { backgroundImage: `url("${url}")` } : {};
}
